<!-- Similar to ConfirmModal, but you provide an array of buttons instead of it being a no/yes choice. -->
<!-- It does still provide a cancel button. -->
<template>
    <Modal class="custom-confirm-modal confirm-modal"
           :icon="icon"
           :title="title"
           :custom-title-text="customTitleText"
           :size="modalSize">
        <DialogText :text-lang-keys="textLangKeys"
                    :custom-text="customText"
                    :custom-html="customHtml " />

        <template v-slot:footer>
            <div class="modl-footer confirm-modal__btns">
                <DialogCancelBtn :color="cancelColor"
                                 :custom-text="cancelCustomText"
                                 :label="cancelLabel"
                                 @click="cancel" />

                <SquareBtn v-for="btn in btns"
                           :key="`btn-${btn.label}`"
                           :color="btn.color"
                           :disabled="!!btn.disabled"
                           size="lg"
                           block
                           @click="resolve(btn.value)">
                    {{ l(btn.label) }}
                </SquareBtn>
            </div>
        </template>
    </Modal>
</template>

<script>
import DialogCancelBtn from '@/vue/modals/Dialogs/components/DialogCancelBtn';
import DialogText from '@/vue/modals/Dialogs/components/DialogText';
import Modal from '@/vue/components/Modals/Modal';
import SquareBtn from '@/vue/components/SquareBtn';
import { DialogPropsMixin } from '@/vue/modals/Dialogs/mixins/DialogPropsMixin';
import { ModalPropsMixin } from '@/vue/mixins/ModalPropsMixin';

export default {
    components: {
        SquareBtn,
        Modal,
        DialogCancelBtn,
        DialogText,
    },

    mixins: [
        ModalPropsMixin,
        DialogPropsMixin,
    ],

    props: {
        title: {
            type: String,
            default: 'DIALOGS.CONFIRM_TITLE',
        },
        customTitleText: {
            type: String,
            default: null,
        },
        cancelLabel: {
            type: String,
            default: 'CANCEL',
        },
        cancelColor: {
            type: String,
            default: 'default',
        },
        btns: {
            type: Array,
            required: true,
        },
    },
};
</script>
